export const data = {
  buttons: [
    {
      label: 'The flight was delayed',
      id: 'flight-delayed',
    },
    {
      label: 'The flight was cancelled and I was rerouted',
      id: 'flight-rerouted',
    },
    {
      label: 'The flight was cancelled and I did not fly',
      id: 'flight-cancelled',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/f6e85a5bbbb3-tooliconflighttimes.jpg',
  },
  title: 'Was the flight delayed or cancelled?',
}
